export const TIMELINE_FILTER_UPDATE = 'TIMELINE_FILTER_UPDATE';
export const TIMELINE_FILTER_CLEAR = 'TIMELINE_FILTER_CLEAR';
export const HEALTH_SUMMARY = 'HEALTH_SUMMARY';
